<template>
  <div class="reg_wrapper">
    <div class="container">
      <div class="main">
        <div class="breadcrumb">
          当前位置: <span @click="returnIndex"><a>首页</a></span> >
          <span>找回注册</span>
        </div>
        <div class="line"></div>
        <div class="lead">找回注册<span></span></div>
        <div class="reg reg-input reg-select">
          <div class="nav">
            <div class="title">单位信息</div>
          </div>
          <div class="line">
            <div></div>
          </div>
          <div class="form">
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>单位名称
              </div>
              <div class="value">
                <el-input
                  placeholder="请输入单位名称"
                  v-model="model.comfullname"
                  clearable
                ></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span style="color: red">* </span>统一信用代码
              </div>
              <div class="value input-code">
                <el-input
                  @blur="isExistComName"
                  placeholder="请输入统一信用代码"
                  v-model="model.comidcode"
                  clearable
                ></el-input>
              </div>
              <div class="searchbtn">
                <span @click="isExistComName">查询</span>
              </div>
            </div>
          </div>
          <div class="tablelist">
            <div class="list page3_list_table_th">
              <div class="page3_list_table">
                <el-table
                  highlight-current-row
                  :data="userList"
                  style="width: 100%"
                >
                  <el-table-column prop="name" label="单位名称" width="300">
                    <template>
                      {{ model.comfullname }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="统一信用代码" width="280">
                    <template>
                      {{ model.comidcode }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="姓名">
                    <template slot-scope="scope">
                      {{ getPrivateName(scope.row.username) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="手机号码">
                    <template slot-scope="scope">
                      {{ getPrivateTel(scope.row.usermobile) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="状态">
                    <template slot-scope="scope">
                      {{ scope.row.userstatusdesc }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="mobile-tablelist">
            <div class="row">
              <div class="cell">单位名称</div>
              <div class="cell">统一信用代码</div>
              <div class="cell">姓名</div>
              <div class="cell">手机号</div>
              <div class="cell">状态</div>
            </div>
            <div class="row" v-for="(item, index) in userList" :key="index">
              <div class="cell">
                {{ model.comfullname }}
              </div>
              <div class="cell">
                {{ model.comidcode }}
              </div>
              <div class="cell">
                {{ getPrivateName(item.username) }}
              </div>
              <div class="cell">
                {{ getPrivateTel(item.usermobile) }}
              </div>
              <div class="cell">
                {{ item.userstatusdesc }}
              </div>
            </div>
          </div>
          <div class="content">
            <div v-if="userList.length" class="alertmsg">
              <div>以上数据有您的登录账号吗？</div>
              <span @click="showUpload = true">没有，以上都不是。</span>
            </div>
            <div class="alertmsg" v-if="showUpload">
              请按照以下范例填写《找回账号密码申请》并上传该申请文件及相关附件，
              <span class="excel"
                >点击下载《<span @click="downloadfile"
                  >找回账号密码申请.docx</span
                >
                <!--<a :href="excelPath" style="color:#20a0ff">找回账号密码申请</a>-->
                》</span
              >
            </div>
            <div v-if="showUpload" class="upload">
              <upload-btn @changed="setfile" text="上传文件"></upload-btn>
              <div v-if="appendList && appendList.length" class="filelist">
                <div
                  v-for="(append, index) in appendList"
                  :key="index"
                  class="fileitem"
                >
                  <div class="name" @click="downFile(append.appendurl)">
                    <a :src="$store.getters.picAddr + append.appendurl">{{
                      append.appendfilename
                    }}</a>
                  </div>
                  <div class="delbtn" @click="delappend(append)">
                    <span>删除</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isShowReg" class="alertmsg">
              没有找到该单位，点击
              <span @click="$router.push({ path: '/reg' })">立即注册</span>
            </div>
            <div class="split">
              <div></div>
            </div>
            <div class="fileimg" v-if="showUpload">
              <div class="title">找回账号密码申请填写范例：</div>
              <img class="img1" src="../assets/img/example1.png" />

              <!--<img  class="img2" src="../assets/img/file1.png"/>-->
              <!--<img   class="img3" src="../assets/img/file2.png"/>-->
              <div class="split">
                <div></div>
              </div>
              <div>
                <div class="img2">
                  <div class="title">附件1</div>
                  <div>
                    <img src="../assets/img/file1.png" />
                  </div>
                </div>
                <div class="split">
                  <div></div>
                </div>
                <div class="img3">
                  <div class="title">附件2</div>
                  <div><img src="../assets/img/file2.png" /></div>
                </div>
              </div>
            </div>
          </div>
          <a>
            <!--<div class="btn" @click="submit">知道了</div>-->
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import uploadBtn from "../components/common/uploadBtn";
import common from "@/mixin/common";
import request from "@/utils/request";

export default {
  name: "reg.vue",
  mixins: [common],
  components: { uploadBtn },
  data() {
    return {
      isShowReg: false,
      showUpload: false,
      com: "",
      model: {
        comid: 0,
        comfullname: "",
        comidcode: "",
        usercode: "",
      },
      userList: [],
      errMsg: "",
      appendList: [],
    };
  },
  mounted() {
    if (this.$route.params.com) {
      this.model = this.$route.params.com;
      this.isExistComName();
    }
  },
  methods: {
    downloadfile() {
      var tempwindow = window.open("_blank");
      tempwindow.location = this.excelPath;
    },
    getPrivateTel(val) {
      return val.slice(0, 3) + "****" + val.slice(7, val.length);
    },
    getPrivateName(val) {
      return val.slice(0, 1) + "**";
    },
    returnIndex() {
      this.$router.replace({ path: "/" });
    },
    async getAppends() {
      this.appendList = await request({
        method: "get",
        url: "/web/web/getAppendListByFromId",
        params: { appendfromid: this.com.comid, appendfromtype: 9 },
      });
    },
    async isExistComName() {
      if (this.model.comfullname && this.model.comidcode) {
        let userData = await request({
          url: "/web/web/isExistComName",
          method: "get",
          params: {
            comfullname: this.model.comfullname,
            comidcode: this.model.comidcode,
          },
        });
        if (userData.data) {
          this.com = userData.data;
          this.userList = userData.user;
          this.showUpload = false;
          this.isShowReg = false;
          this.getAppends();
          // if (this.userList.length) {
          //   let index = this.userList.findIndex(v => +v.userstatus === 1)
          //   if (index === -1) {
          //     this.showUpload = true
          //   } else {
          //     this.showUpload = false
          //   }
          // }
        } else {
          this.isShowReg = true;
          this.userList = [];
          this.showUpload = false;
        }
      }
    },
    async delappend(file) {
      this.$confirm(`确定删除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(async () => {
          let data = await request({
            url: "/ywgl/append/delAppend",
            method: "post",
            data: { appendid: file.appendid },
          });
          if (data.issuccess === 1) {
            await this.getAppends();
            this.$message.success("文件删除成功");
          } else {
            this.$message.error("文件删除失败");
          }
          this.getAppends();
        })
        .catch(() => {});
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: this.com.comid,
        appendfromtype: "9",
        appendtype: "7",
        appendseq: this.appendList.length ? this.appendList.length + 1 : 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      let data = await request({
        url: "/ywgl/append/addOrEdit",
        method: "post",
        data: append,
      });
      if (data.issuccess === 1) {
        await this.getAppends();
        this.$message.success("文件上传成功");
      } else {
        this.$message.error("文件上传失败");
      }
    },
  },
  computed: {
    ...mapGetters(["cosId", "picAddr"]),
    excelPath() {
      return this.$store.getters.picAddr + "upload/file/找回账号密码申请.docx";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .mobile-tablelist {
    display: none;
  }
  .reg_wrapper {
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      .main {
        margin-top: 38px;
        padding: 23px 20px 40px;
        width: 1201px;
        background-color: $color-bg-white;
        .line {
          height: 2px;
          border-bottom: 1px solid #eaeaea;
          div {
            border-bottom: 3px solid $color-orange;
            width: 65px;
          }
          .radio {
            border-bottom: 3px solid $color-orange;
            width: 95px;
          }
        }
        .split {
          height: 2px;
          padding: 10px 0;
          border-bottom: 1px solid #eaeaea;
        }
        .active {
          div {
            border-bottom: 3px solid $color-orange;
            margin-left: 140px;
            width: 85px;
          }
        }
        .breadcrumb {
          font-size: $fontsize-medium;
          color: $color-text-secondary-gray;
          padding-bottom: 10px;
          > :first-child {
            padding-left: 10px;
            a:hover {
              color: $color-orange;
            }
          }
        }
        .lead {
          border-left: 4px solid $color-orange;
          font-weight: bold;
          font-size: $fontsize-large-x;
          margin: 40px 0 60px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          span {
            font-weight: normal;
            font-size: $fontsize-medium;
            color: $color-text-secondary-gray;
          }
        }
        .reg {
          padding-left: 14px;
          .nav {
            display: flex;
            .title {
              cursor: pointer;
              margin-right: 50px;
              padding-bottom: 18px;
              font-weight: bold;
              font-size: $fontsize-large;
            }
          }
          .form {
            font-size: $fontsize-medium;
            padding: 32px 0 60px;
            .row {
              display: flex;
              align-items: center;
              padding: 10px 0;
              width: 448px;
              .label {
                text-align: right;
                width: 110px;
                margin-right: 10px;
              }
              .value {
                flex: 1;
                span {
                  color: $color-text-secondary-gray;
                }
              }
              .searchbtn {
                cursor: pointer;
                border: 1px solid $color-orange;
                padding: 11px;
                margin-left: 10px;
                color: $color-orange;
              }
            }
          }
          .btn {
            width: 318px;
            margin-left: 130px;
            text-align: center;
            background-color: $color-orange;
            padding: 15px;
            font-size: $fontsize-large-x;
            color: #fff;
          }
          .content {
            padding-left: 40px;
            padding-top: 20px;
            .upload {
              /*display: flex;*/
              /*align-items: flex-start;*/
              width: 35%;
              padding-bottom: 20px;
              .filelist {
                /*width: 100%;*/
                padding-top: 10px;
                .fileitem {
                  display: flex;
                  text-align: left;
                  line-height: 40px;
                  .name {
                    color: #2f74ff;
                    cursor: pointer;
                    flex: 1;
                  }
                  .delbtn {
                    padding: 0 10px;
                    span {
                      color: #2f74ff;
                      cursor: pointer;
                    }
                  }
                  /*height: 150px;*/
                }
              }
            }
            .alertmsg {
              font-size: $fontsize-medium;
              padding-bottom: 20px;
              display: flex;
              justify-content: flex-start;
              span {
                cursor: pointer;
                color: $color-orange;
                /*border-bottom: 1px solid $color-orange;*/
                /*margin-right: 20px;*/
              }
            }
            .fileimg {
              /*display: flex;*/
              .title {
                font-size: $fontsize-large;
                font-weight: bold;
                padding: 10px 0;
              }
              .img1 {
                img {
                  width: 498px;
                  height: 732px;
                }
              }
              .img2 {
                img {
                  width: 534px;
                  height: 429px;
                }
              }
              .img3 {
                img {
                  width: 445px;
                  height: 386px;
                }
              }
            }
          }
          .tablelist {
            padding: 0 20px 0;
            .list {
              .jiantou {
                color: $color-text-secondary-gray;
              }
              .page {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: $color-bg-white;
                padding: 27px 0;
              }
              .btn {
                font-size: $fontsize-medium;
                cursor: pointer;
                color: $color-orange;
                display: flex;
                .button {
                  padding: 1px 18px;
                  border: 1px solid $color-orange;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .main {
    margin: 5em 0;
    .breadcrumb {
      font-size: 0.9em;
      color: #999999;
      margin: 1em 0;
    }
    .lead {
      font-size: 1em;
      font-weight: bold;
      border-left: 0.2em solid #f46722;
      width: 4.6em;
      margin: 1em 0.6em;
    }
    .reg {
      .nav {
        .title {
          font-size: 1em;
          font-weight: bold;
          border-bottom: 0.1em solid #f46722;
          padding: 0.7em 0;
          margin: 1em 0.6em;
          width: 4.6em;
        }
      }
      .form {
        .row {
          display: flex;
          align-items: center;
          margin: .6em 0;
          .label {
            width: 7.6em;
            text-align: right;
            padding-right: .6em;
          }
          .value {
          }
          .input-code {
            width: 10em;
          }
          .searchbtn {
            margin-left: 0.6em;
            padding: 0.5em 0.5em;
            color: #f46722;
            border: 0.1em solid #f46722;
          }
        }
      }
      .tablelist {
        display: none;
      }
      .mobile-tablelist {
        display: table;
        text-align: center;
        font-size: 1em;
        width: 100%;
        color: #999;
        margin: 1em 0;
        .row {
          display: table-row;
          .cell {
            display: table-cell;
            width: 5em;
            border-bottom: 1px dotted #999;
            padding: .6em 0;
            &:nth-child(3),
            &:nth-child(5) {
              width: 2em;
            }
          }
        }
      }
    }
  }
}
</style>
